import Vue from 'vue'
import RegionPicker from './RegionPicker'
import Logo from './Logo'
import CartStep from './CartStep'
import Category from './Category'
import CountDownBtn from './CountDownBtn'
import Face from './Face'
import Footer from './Footer'
import Header from './Header'
import HeaderOther from './HeaderOther'
import Nav from './Nav'
import Operation from './Operation'
import PicZoom from './PicZoom'
import Search from './Search'
import Settleup from './Settleup'
import Shortcut from './Shortcut'
import ShopLogo from './ShopLogo'
import AddPurchase from './AddPurchase'
import RegionCascader from './RegionCascader'

export {
  RegionPicker,
  Logo,
  CartStep,
  Category,
  CountDownBtn,
  Footer,
  Face,
  Header,
  HeaderOther,
  Nav,
  Operation,
  PicZoom,
  Search,
  Settleup,
  Shortcut,
  ShopLogo,
  AddPurchase,
  RegionCascader
}



// WEBPACK FOOTER //
// ./src/components/index.js